import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button, Grid, Table, Dropdown } from 'semantic-ui-react';
import InfoIcon from '@material-ui/icons/Info';
import $ from "jquery";

import Title from '../../title';
import Server from '../../../functions/server';
import Loading from '../../loading';
import GSTReport from './GSTReport';
import Permission from '../../../functions/permission';
import CustomerDetails from '../../others/customerdetails';


class SalesType extends Component {

  state = {
    fromDate: this.getFormatedDate(new Date(), 7),
    toDate: this.getFormatedDate(new Date()), menuPermission: [],
    report: [], salesType: [], selectedSalesType: 'ALL', branchs: [], selectedBranch: 'ALL'
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month >= 10) ? month : "0"+ month;
    date = (date >= 10) ? date : "0" + date;
    let x = dates.getFullYear() + "-" + month + "-" + date;
    if (interval == 7) {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    return x;
  }

  componentDidMount() {
    this.menuPermission();
  }

  menuPermission() {
    let menuPermission = Permission('sales-report', this.props.menus);
    if (menuPermission.view) {
      this.getBranch();
      this.getSalesTypeReport();
      this.getSalesType();
    }
    this.setState({ menuPermission })
  }

  getBranch = () => {
    let context = this;
    $.ajax({
      type: 'POST',
      url: Server() + 'branchdetails/getallbranchs.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          let branchs = [];
          branchs.push({ key: 'ALL', value: 'ALL', text: 'ALL' });
          data.map((c) => {
            branchs.push({ key: c.name, value: c.id, text: c.name });
          })
          context.setState({ branchs })
        } catch (e) {
        }
      },
      error: function(err)
      {
        alert('Try again!!!!')
      }
    });
  }

  getSalesTypeReport = () => {
    let context = this;
    let { fromDate, toDate, selectedSalesType, selectedBranch } = this.state;
    this.setState({ load: true, message: 'Getting GST REPORT!!!!' })
    $.ajax({
      type: 'POST',
      data: { fromDate, toDate, selectedSalesType, selectedBranch },
      url: Server() + 'salesreport/getreport.php',
      success: function(data) {
        alert(data)
        try {
          data = JSON.parse(data);
          context.setState({ report: data, load: false })
        } catch (e) {
          alert('Error to get Data!!!');
          context.setState({ load: false })
        }
      },
      error: function (e) {
        alert('Error')
        context.setState({ load: false });
      }
    });
  }

  getSalesType = () => {
    let context = this;
    let salesType = [];
    salesType.push({ text: 'ALL', value: 'ALL', key: 'ALL' });
    salesType.push({ text: 'Counter Sale', value: 'Counter Sale', key: 'Counter Sale' });
    salesType.push({ text: 'Wholesale', value: 'Wholesale', key: 'Wholesale' });
    salesType.push({ text: 'Paid(Service)', value: 'Paid(Service)', key: 'Paid(Service)' });
    salesType.push({ text: 'Warranty(Service)', value: 'Warranty(Service)', key: 'Warranty(Service)' });
    context.setState({ salesType })
  }

  convertToNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  makeDecimalPoint(value) {
    try {
      value = Number(value).toFixed(2);
    } catch (e) {
      value = 0.00;
    }
    return value;
  }

  dataSeprate(value) {
    value = value.split(" ")[0];
    value = value.split("-")[2]+'-'+value.split("-")[1]+"-"+value.split("-")[0];
    return value;
  }

  onChange = (type) => (f, { value }) => { this.setState({ [type]: value }) }

  exports = () => {
    if (!this.state.menuPermission.exports) {
      alert('You Are Not Allow To Export!!!');
      return;
    }
    let downloadLink;
    let filename = 'SalesReport';
    let dataType = 'application/vnd.ms-excel';
    let tableSelect = document.getElementById('table');
    let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    filename = filename?filename+'.xls':'excel_data.xls';
    downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    if(navigator.msSaveOrOpenBlob) {
      let blob = new Blob(['\ufeff', tableHTML], {
          type: dataType
      });
      navigator.msSaveOrOpenBlob( blob, filename);
    }
    else {
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
      downloadLink.download = filename;
      downloadLink.click();
    }
  }

  openInvoice(quotationId, customerId) {
    let open = 'https://vaigaiclaas.com/api/v1/web/pdf/placeorderpdf2.php?quotationId='+quotationId+'&customerId='+customerId+'&bankId=0';
    window.open(open);
  }

  getGstReport = (id) => {
    let context = this;
    $.ajax({
      type: 'POST', data: { id },
      url: Server() + 'salesreport/getdetails.php',
      success: function(data) {
        alert(data)
        try {
          data = JSON.parse(data);
          let branchs = [];
          branchs.push({ key: 'ALL', value: 'ALL', text: 'ALL' });
          data.map((c) => {
            branchs.push({ key: c.name, value: c.id, text: c.name });
          })
          context.setState({ branchs })
        } catch (e) {
        }
      },
      error: function(err)
      {
        alert('Try again!!!!')
      }
    });
  }

  render() {
    let total = 0;
    let sino = 1;
    this.state.report.map((c) => { total =  total +  this.convertToNumber(c.amount); })
    return (
      <div>
        <Title title={'Sales Report'} openDrawer={this.props.openDrawer}/>
        <Loading load={this.state.load} message={this.state.message} />
        {
          this.state.menuPermission.view ? 
          (
            <div style={{margin: '0.5%'}}>
              <div style={{display: 'flex'}}>
                <TextField label="From" type="date" style={{marginTop: '1%'}}
                  onChange={(e) => this.setState({fromDate: e.target.value})}
                  defaultValue={this.state.fromDate} />
                <TextField style={{marginLeft: 20, marginTop: '1%'}} label="To" type="date"
                  onChange={(e) => this.setState({toDate: e.target.value})}
                  defaultValue={this.state.toDate} />

                <div>
                  Branch<br/>
                  <Dropdown
                    onChange={this.onChange('selectedBranch')}
                    search selection options={this.state.branchs}
                    value={this.state.selectedBranch} style={{ borderColor: '#5A9CBB', fontSize: 14, marginLeft: '1.5%' }} />
                </div>

                <div>
                  Sales Type<br/>
                  <Dropdown
                    onChange={this.onChange('selectedSalesType')}
                    search selection options={this.state.salesType}
                    value={this.state.selectedSalesType} style={{ borderColor: '#5A9CBB', fontSize: 14, marginLeft: '1.5%' }} />
                </div>
                <Button variant="contained" color="primary" style={{marginLeft:20, marginTop: '1.5%', height: '5%'}} onClick={this.getSalesTypeReport}>Go</Button>
                <Button variant="contained" color="primary" style={{marginLeft:20, marginTop: '1.5%', height: '5%'}} onClick={this.exports}>Export</Button>
                <div style={{fontSize: 17, color: '#3E71A4', width: '32%', textAlign: 'right', marginTop: '1.5%'}}><br/>{'Rs.'+this.makeDecimalPoint(total)}</div>
              </div>
              <table width="100%" id="table">
                <tr>
                  <th id='tableheader'><center>Sino</center></th>
                  <th id='tableheader'><center>Serial No</center></th>
                  <th id='tableheader'><center>Data</center></th>
                  <th id='tableheader'><center>Branch</center></th>
                  <th id='tableheader'><center>Voucher No</center></th>
                  <th id='tableheader'><center>Customer Name</center></th>
                  <th id='tableheader'><center>Sales Type</center></th>
                  <th id='tableheader'><center>Total</center></th>
                  <th id='tableheader'><center>Info</center></th>
                </tr>
                {
                  this.state.report.map((c) => {
                    return (
                      <tr>
                        <td>{sino++}</td>
                        <td>{c.serialno}</td>
                        <td>{this.dataSeprate(c.invoice_date)}</td>
                        <td>{c.branch_name}</td>
                        <td style={{ cursor: 'pointer' }} onClick={this.openInvoice.bind(this, c.id, c.customer_id)}>
                          <u>{c.invoice_voucher}</u>
                        </td>
                        <td><CustomerDetails customerId={c.customer_id} customerName={c.name} /></td>
                        <td>{c.salestype}</td>
                        <td><div style={{textAlign: 'right'}}>{this.makeDecimalPoint(c.amount)}</div></td>
                        <td>
                          <GSTReport item={c} />
                        </td>
                      </tr>
                    )
                  })
                }
              </table>
            </div>
          ):
          (
            <center>
              You Are Not Allow To Access This Menu!!!
            </center>
          )
        }
      </div>
    );
  }
}

export default SalesType;
